module.exports = __webpack_public_path__ + "img/BM.f7e6c48d.svg";